import { Switch } from "@mui/material";
import React from "react";

function SwitchCompo({value, setValue}) {
  return (
    <Switch
      checked={value}
      onChange={setValue}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
}

export default SwitchCompo;
